var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9531",
    "data-name": "Group 9531",
    transform: "translate(-97.5 -262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 73,
    height: 73,
    rx: 10,
    transform: "translate(97.5 262)",
    fill: "#26c6da",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "users_2_",
    "data-name": "users (2)",
    d: "M5.555,9.629A3.333,3.333,0,1,1,8.889,6.3,3.333,3.333,0,0,1,5.555,9.629Zm0-5.185A1.852,1.852,0,1,0,7.407,6.3,1.852,1.852,0,0,0,5.555,4.444Zm5.555,10.37a3.708,3.708,0,0,0-3.7-3.7H3.7a3.708,3.708,0,0,0-3.7,3.7v2.963H1.481V14.814A2.222,2.222,0,0,1,3.7,12.592h3.7a2.222,2.222,0,0,1,2.222,2.222v2.963h1.481Zm1.852-8.148A3.333,3.333,0,1,1,16.3,3.333a3.333,3.333,0,0,1-3.333,3.333Zm0-5.185a1.852,1.852,0,1,0,1.852,1.852A1.852,1.852,0,0,0,12.963,1.481Zm4.815,10.37a3.708,3.708,0,0,0-3.7-3.7H11.111V9.629h2.963A2.222,2.222,0,0,1,16.3,11.852v2.963h1.481Z",
    transform: "translate(125.418 292.111)",
    fill: "#26c6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26060",
    "data-name": "Path 26060",
    d: "M74.6,248.556a11.938,11.938,0,0,0-.036-1.238A3.785,3.785,0,0,0,72.1,244.08a3.89,3.89,0,0,0-1.27-.235c-.1,0-.192,0-.292,0s-.185,0-.278,0c-1.231-.014-2.466,0-3.7,0-.231,0-.463-.032-.74-.057a3.15,3.15,0,0,0-2.092-3.548H50l-.053.021a3.151,3.151,0,0,0-2.035,3.523c-.306.021-.559.06-.811.06-1.2.007-2.409-.011-3.612,0-.093,0-.185,0-.278,0-.132,0-.263,0-.395,0a3.88,3.88,0,0,0-2.057.623l-.1.064a3.234,3.234,0,0,0-1.2,1.409c-.018.036-.036.075-.053.11s-.032.082-.05.125a3.989,3.989,0,0,0-.288,1.142l-.011.139c-.032.363-.028.729-.028,1.1q-.005,11.609,0,23.225v6.48a8.163,8.163,0,0,0,.242,2.284c.367,1.21,1.2,1.854,2.914,2.576H71.46c1.637-.69,2.466-1.313,2.85-2.427a7.529,7.529,0,0,0,.292-2.434V270.87Q74.6,259.71,74.6,248.556Zm-23-4.7H62.084v3.473H51.6ZM71.09,278.642c-.007.715-.235.918-.964.911-3.786-.021-7.572-.018-11.358-.018H54.943c-3.807,0-7.611,0-11.419.018-.751.007-.971-.206-.968-.968v-.011q.016-6.181.018-12.365.005-8.962-.014-17.923a2.236,2.236,0,0,1,.025-.363v-.007a.593.593,0,0,1,.548-.573h1.174a.086.086,0,0,1,.043,0c.907.007,1.822,0,2.758,0h.786c.011.085.018.171.021.249a7.4,7.4,0,0,0,.011.808,2.706,2.706,0,0,0,1.341,2.167c.057.032.114.064.171.089a1.765,1.765,0,0,0,.171.075c.078.032.157.057.238.082a2,2,0,0,0,.253.057c.085.018.174.028.263.039s.178.011.27.011q6.213.021,12.433,0h.028a2.677,2.677,0,0,0,2.719-2.519c.028-.31,0-.626,0-1.057h.729c.936,0,1.85.011,2.761,0a.1.1,0,0,1,.046,0H70.51c.466.071.576.377.576.943q-.011,6.949-.014,13.9v3.96q0,1.345,0,2.687,0,2.2,0,4.4.005,2.679.011,5.355Z",
    transform: "translate(77.49 36.725)",
    fill: "#26c6da",
    stroke: "#daf6f9",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalClients);
export default __webpack_public_path__ + "static/media/totalClients.6cab9a38f360a5d8e4174d8a051f35d4.svg";
export { ForwardRef as ReactComponent };